// extracted by mini-css-extract-plugin
export default {"CatchImageContainer":"CatchHeader_CatchImageContainer__uAgx8","ImgDimentions":"CatchHeader_ImgDimentions__WGms7"};